/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

function configs(labels: any, datasets: any) {
	return {
		data: {
			labels,
			datasets: [...datasets],
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					display: false,
				},
			},
			interaction: {
				intersect: false,
				mode: 'index',
			},
			scales: {
				y: {
					grid: {
						drawBorder: false,
						display: true,
						drawOnChartArea: true,
						drawTicks: false,
						borderDash: [5, 5],
						color: '#c1c4ce5c',
					},
					ticks: {
						display: true,
						padding: 10,
						color: '#9ca2b7',
						font: {
							size: 14,
							weight: 300,
							family: 'Roboto',
							style: 'normal',
							lineHeight: 2,
						},
					},
				},
				x: {
					grid: {
						drawBorder: false,
						display: true,
						drawOnChartArea: true,
						drawTicks: true,
						borderDash: [5, 5],
						color: '#c1c4ce5c',
					},
					ticks: {
						display: true,
						color: '#9ca2b7',
						padding: 10,
						font: {
							size: 14,
							weight: 300,
							family: 'Roboto',
							style: 'normal',
							lineHeight: 2,
						},
					},
				},
			},
		},
	}
}

export default configs
